//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import cx from 'classnames';
import { ReactNode } from 'react';

import './FormSection.less';

export interface FormSectionProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export const FormSection = ({ title, children, className }: FormSectionProps) => {
  return (
    <div className={cx('synri-form-section', className)}>
      {title && <h3 className="synri-form-section__title">{title}</h3>}
      <div className="synri-form-section__content">{children}</div>
    </div>
  );
};
